import type { DynamoDB } from '@aws-sdk/client-dynamodb';
import * as React from 'react';

export const AnalyticsAccountDynamoDbClientContext = React.createContext<DynamoDB | null>(null);

/** Get the Analytics Account Dynamo DB client */
export function useAnalyticsAccountDynamoDbClient(): DynamoDB | null {
  return React.useContext(AnalyticsAccountDynamoDbClientContext);
}
